import { Tooltip } from '@/components/tooltip';
import { Label } from '@/components/ui/label';
import { ReactNode } from '@tanstack/react-router';
import clsx from 'clsx';
import { Info } from 'lucide-react';
import React from 'react';

/**
 * A stacked key/value display widget
 * @returns
 */
export const InfoKeyValue: React.FC<{
  label: ReactNode;
  labelTooltip?: ReactNode;
  value?: React.ReactNode;
  edit?: {
    editing?: boolean;
    editModeComponent: React.ReactNode;
  };
  className?: string;
  labelClassName?: string;
  'data-testid'?: string;
}> = ({ label, value, edit, className, labelClassName, 'data-testid': dataTestId, labelTooltip }) => {
  const isEditMode = edit?.editing;
  return (
    <>
      {isEditMode ? (
        edit.editModeComponent
      ) : (
        <div className={clsx('space-y-2', className)}>
          <div className="flex gap-2 items-center">
            <Label className="font-bold" data-testid={dataTestId ? `${dataTestId}-label` : undefined}>
              {label}
            </Label>
            {labelTooltip && <Tooltip trigger={<Info className="h-5 w-5" />}>{labelTooltip}</Tooltip>}
          </div>
          {typeof value === 'string' ? (
            <p className={labelClassName} data-testid={dataTestId ? `${dataTestId}-value` : undefined}>
              {value}
            </p>
          ) : (
            <div data-testid={dataTestId ? `${dataTestId}-value` : undefined}>{value}</div>
          )}
        </div>
      )}
    </>
  );
};
